// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // resourcePrefix:'https://stagingapi.polysports.io/admin/resource/file/'
  resourcePrefix: 'https://api.polysports.io/admin/resource/file/',
  apiUrl: "https://merchantapi.nukhba.app/api/v1/",
  // apiUrl: 'http://localhost:3000/api/v1/',

  //apiUrl: "https://betamerchantapi.nukhba.app/api/v1/",
  firebaseConfig: {
    apiKey: "AIzaSyAhPA38jHfSEJoXpy_n_uAwJL2WgCj2tSQ",
    authDomain: "foodapp-5b8f5.firebaseapp.com",
    projectId: "foodapp-5b8f5",
    storageBucket: "foodapp-5b8f5.appspot.com",
    messagingSenderId: "528741565426",
    appId: "1:528741565426:web:9182cb6b6330252f6aa16b",
    measurementId: "G-Q09JGP2G2R"
  },
  fcm_server_key:'AAAAext0A_I:APA91bEyiRw3Jcxxg7eHRKzvLr4nFB4PONJB7fRNOigAZ9D1MFUzJQ9wFzriEzOxg4sykAWNdTz8Em7yWmCmwPB9Pd6bQrdl5jqnlrljrxgM_yywmO8HA0TqsOAsduDk-kWpYDn7HwUe',
  // vapidKey: "BMw7mcT_iTvahQM-oGFUHGYF8FfTk7vQjbMJ5rgmTIXVr79qylWfaZ5M1ngGbGjub3HogMzc-nM6KG1qUC3wOAc",
  vapidKey: "BOsAj2rScPws_Zoq3CQcO19Dahf-hGvJK2KkvBh76JRerjQdXjy9VrxRdUTodxGUjRPeyvYqaHKwE9v_HrzKwEc",

  //apiUrl: "https://merchantapi.polysports.com/api/v1/",
  gmailSocialLoginKey: "528741565426-bivpt9k1ukfm1hga7n41ubbur6eb2v6l.apps.googleusercontent.com",
  scope: "email",
  pluginName: "Web client  (auto created by Google Service)",
  name: 'Nukhuba',

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
